import { cookie } from '@pdrj/pmi-iqos-shared-react'
import { getPaginationParams } from '@iqosphere-common/utils'

export default class IqosphereSpots {
  constructor(api) {
    this.api = api
  }

  getSpots = async data => {
    return await this.api.get(
      '/iqosphere/spots' + getPaginationParams(0, 1000, true),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        params: data,
        mock: this.api.getMock('getSpots')
      }
    )
  }

  getSpotDetail = async id => {
    return await this.api.get(`/iqosphere/spots/${id}/venue`, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getSpotDetail')
    })
  }
}
